/**
 * @generated SignedSource<<2d30c13b43a07c9887a7a00d4caa457c>>
 * @relayHash 7010725e85aa41e14f8d9ab65ef666f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 932257e39544218ca3dcb31b62b79dd3cdfb39359df89daf3414f4ab3959a01f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomerServiceReportedByFilter = "OTHER" | "USER" | "%future added value";
export type CustomerServiceStatusKey = "RESOLVED" | "SUBMITTED" | "%future added value";
export type CustomerServiceRequestFilterInput = {
  reportedBy?: CustomerServiceReportedByFilter | null | undefined;
  searchText?: string | null | undefined;
  status?: CustomerServiceStatusKey | null | undefined;
  statusFilter?: ReadonlyArray<string> | null | undefined;
};
export type csmRequestsListQuery$variables = {
  accountId: string;
  cloudId: string;
  count?: number | null | undefined;
  filter?: CustomerServiceRequestFilterInput | null | undefined;
  helpCenterId: string;
};
export type csmRequestsListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"requestsTable_csmRequestsList">;
};
export type csmRequestsListQuery = {
  response: csmRequestsListQuery$data;
  variables: csmRequestsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterId"
},
v5 = {
  "kind": "Variable",
  "name": "accountId",
  "variableName": "accountId"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v8 = {
  "kind": "Variable",
  "name": "helpCenterId",
  "variableName": "helpCenterId"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v8/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "requestsTable_csmRequestsList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/)
        ],
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "individualByAccountId",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "CustomerServiceRequestConnection",
                    "kind": "LinkedField",
                    "name": "requests",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CustomerServiceRequestEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "CustomerServiceRequest",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "statusKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "externalStatus"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "statusCategoryName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "createdOn"
                              },
                              {
                                "concreteType": "CustomerServiceTemplateForm",
                                "kind": "LinkedField",
                                "name": "templateForm",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "name"
                                  },
                                  (v11/*: any*/)
                                ]
                              },
                              (v11/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v10/*: any*/),
                    "filters": [
                      "helpCenterId",
                      "filter"
                    ],
                    "handle": "connection",
                    "key": "requestsTable_requests",
                    "kind": "LinkedHandle",
                    "name": "requests"
                  }
                ],
                "type": "CustomerServiceIndividual"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "932257e39544218ca3dcb31b62b79dd3cdfb39359df89daf3414f4ab3959a01f",
    "metadata": {},
    "name": "csmRequestsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d74f8c48f260adbcba9adc4408d02fde";

export default node;
